import {Component, OnInit} from '@angular/core';
import {LeadService} from '../services/lead.service';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {LeadsAdvanceSearch} from '../../housekeeping/models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import * as moment from 'moment';
import {ExportAvailability} from '../../../config';
import {Router} from '@angular/router';

@Component({
    selector: 'app-lead-export',
    templateUrl: '../views/lead-export.component.html',
    styleUrls: ['../css/lead-export.component.css']
})
export class LeadExportComponent implements OnInit {

    public userId: string;
    public statusList: any;
    public countryList: any = [];
    public current: any = [];
    public remaining: any = [];
    public index: number;
    public addToRemaining: any = [];
    public addTocurrent: any = [];
    public limit: number = 10;
    public offset: number = 0;
    public showBack: boolean = false;
    public showNext: boolean = false;
    public noData: boolean = false;
    public data: any = [];
    public advancesearchfields = new LeadsAdvanceSearch("", "", "", "", null, null, null, null, null, null,null, 0, 10, null, null, false, "", "ASC",[],[],"",[], false);
    public lastname: any;
    public showsubmission: boolean = true;
    public showsubmissionrange: boolean = false;
    public leadSourceList: any;
    public prepareData: any = [];
    public savePreference: any;
    public prepareCurrentToSave: any = [];
    public finalExportData: any = [];
    public temp: any;
    public headerData: any = [];
    public rowdata: any = [];
    public refine: any = [];
    public columns: any = [];
    public enablePagination: boolean = true;
    public exportData: any;
    public showRequiredMsg: boolean = false;
    public moveToTab2: boolean = false;
    public EXPORT = ExportAvailability.export;

    public eventValues: any = [];
    public VOIWithMakeModel: any = [];
    //dropdown values
    public statusSelected: any = [];
    public eventIdSelected: any = [];
    public countrySelected: any = [];
    public leadSelected: any = [];
    public VOISelected: any = [];
    public VPSelected: any = [];
    //Boolean
    public isStatusAll: boolean = false;
    public isEventIdAll: boolean = false;
    public isCountryAll: boolean = false;
    public isLeadAll: boolean = false;
    public isVOIAll: boolean = false;
    public isVPAll: boolean = false;

    public vehiclePurposeList:any;

    //Settings for dropdowns
    public statusSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'statusType',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public eventSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'idWithDescription',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public leadSourceSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'sourceType',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public countrySettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'namecode',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public VOISettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'makeModel',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public VPSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'description',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };

    constructor(public _leadService: LeadService, public _dataService: GlobalDataService, private _router: Router) {}

    ngOnInit() {
        if (!this.EXPORT) {
            this._router.navigate(['/leads']);
        }
        //this.userId = localStorage.getItem('userId');
        this.userId = sessionStorage.getItem('userId');

        this.getStatusList();
        this.getCountryList();
        this.getLeadSourceList();
        this.getPreference();
        this.getEventId();
        this.getVOIValues();
             this.getVehiclePurposeList();
        //untill search criteria is entered tab2,3 will be hidden.
      const tab2 = document.getElementById('tab12');
      const tab3 = document.getElementById('tab13');
      tab2.classList.add("disabled");
        tab3.classList.add("disabled");
    }


   /**
     * @author Pradeep
     * @description get vehicle purpose list
     */
    getVehiclePurposeList(){
        this._leadService.getVehiclePurposeList(this.userId, (result) => {
            this.vehiclePurposeList = result;
        });
    }
    getStatusList() {
        this._leadService.getStatusList(this.userId, (result) => {
            this.statusList = result;
        });

    }

    getCountryList() {
        this._leadService.getCountrytWithNameCode(this.userId, result => {
            this.countryList = result

        });
    }

    getLeadSourceList() {
        this._leadService.getLeadSourceList(this.userId, (result) => {
            this.leadSourceList = result;
        });
    }


    fromCurrent(value, index) {
      const assign = document.getElementById("current_" + index);
      assign.classList.toggle("active");
        if (this.addToRemaining.indexOf(value) !== -1) {
            this.index = this.addToRemaining.indexOf(value);
            this.addToRemaining.splice(this.index, 1)
        }
        else {this.addToRemaining.push(value);}
    }

    fromRemaining(value, index) {
      const assign = document.getElementById("remaining_" + index);
      assign.classList.toggle("active");
        if (this.addTocurrent.indexOf(value) !== -1) {
            this.index = this.addTocurrent.indexOf(value);
            this.addTocurrent.splice(this.index, 1)
        }
        else {this.addTocurrent.push(value);}
    }

    filterCurrent() {
        this.addToRemaining.forEach(Obj => {
            this.remaining.push(Obj)
        });
        this.addToRemaining.forEach(each => {
            this.index = this.current.indexOf(each);
            this.current.splice(this.index, 1)
        });
        this.addToRemaining = [];
    }

    filterRemaining() {
        this.addTocurrent.forEach(Obj => {
            this.current.push(Obj)
        });
        this.addTocurrent.forEach(each => {
            this.index = this.remaining.indexOf(each);
            this.remaining.splice(this.index, 1)
        });
        this.addTocurrent = [];
    }

    GoBack() {
        this.offset -= 10;
        if (this.offset == 0) {
            this.showBack = false;
            this.noData = false;
        }
        if (this.offset != 0) {
            this.showNext = true;
        }
        this.advanceSearch();

      const tab11 = document.getElementById("tab11");
      tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");
    }
    /**
     * @author Nagendra
     * @description Get Next Page
     */
    nextPage() {
        this.offset += 10;
        if (this.offset != 0) {
            this.showBack = true;
        }
        this.advanceSearch();

      const tab11 = document.getElementById("tab11");
      tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");
    }


    advanceSearch() {
        //To assign active class
        if (this.advancesearchfields.lastName.trim() != "" ||
            Object.keys(this.statusSelected).length > 0 ||
            this.advancesearchfields.leadNumber.trim() != "" ||
            Object.keys(this.eventIdSelected).length > 0 ||
            Object.keys(this.countrySelected).length > 0 ||
            Object.keys(this.leadSelected).length > 0 ||
            Object.keys(this.VOISelected).length > 0 ||
            Object.keys(this.VPSelected).length > 0 ||
            this.advancesearchfields.submitionDate != null ||
            this.advancesearchfields.fromDate != null ||
            this.advancesearchfields.toDate != null) {
          const tab11 = document.getElementById("tab11");
          tab11.classList.remove("active");
            tab11.classList.add("disabled");
          const tab12 = document.getElementById("tab12");
          tab12.classList.add("active");
            tab12.classList.remove("disabled");
          const tab13 = document.getElementById("tab13");
          tab13.classList.remove("active");
            tab13.classList.add("disabled");

            this.advancesearchfields.statusIds = [];
            this.advancesearchfields.eventIds = [];
            this.advancesearchfields.sourceIds = [];
            this.advancesearchfields.countryIds = [];
            this.advancesearchfields.vehicleOfInterestIds = [];
            this.advancesearchfields.vehiclePurposeIds = [];
            /**
             * @author Nagendra
             * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
             */
            if (Object.keys(this.statusSelected).length > 0 && this.statusSelected != undefined && this.isStatusAll != true) {
                Object.keys(this.statusSelected).map(key => this.advancesearchfields.statusIds.push(this.statusSelected[key]['id']));
            }
            if (Object.keys(this.eventIdSelected).length > 0 && this.eventIdSelected != undefined && this.isEventIdAll != true) {
                Object.keys(this.eventIdSelected).map(key => this.advancesearchfields.eventIds.push(this.eventIdSelected[key]['id']));
            }
            if (Object.keys(this.countrySelected).length > 0 && this.countrySelected != undefined && this.isCountryAll != true) {
                Object.keys(this.countrySelected).map(key => this.advancesearchfields.countryIds.push(this.countrySelected[key]['id']));
            }
            if (Object.keys(this.leadSelected).length > 0 && this.leadSelected != undefined && this.isLeadAll != true) {
                Object.keys(this.leadSelected).map(key => this.advancesearchfields.sourceIds.push(this.leadSelected[key]['id']));
            }
            if (Object.keys(this.VOISelected).length > 0 && this.VOISelected != undefined && this.isVOIAll != true) {
                Object.keys(this.VOISelected).map(key => this.advancesearchfields.vehicleOfInterestIds.push(this.VOISelected[key]['id']));
            }
            if (Object.keys(this.VPSelected).length > 0 && this.VPSelected != undefined && this.isVPAll != true) {
                Object.keys(this.VPSelected).map(key => this.advancesearchfields.vehiclePurposeIds.push(this.VPSelected[key]['id']));
            }

            this.data = [];
            this.advancesearchfields.userId = this.userId;
            this.advancesearchfields.isPagination = this.enablePagination;
            this.advancesearchfields.offset = this.offset;
            this.showRequiredMsg = false;
            this.moveToTab2 = true;
            this._dataService.getSearchLeadList(this.advancesearchfields, (result) => {
                this.data = result;
                if (this.data.beans == "") {
                    this.noData = true;
                    this.showNext = false;
                }
                if (this.data.beans.length <= '10' && this.data.beans != "") {
                    this.showNext = false;
                    this.noData = false;
                }
                if (this.data.beans.length == '10') {
                    this.showNext = true;
                    this.noData = false;
                }
            })
        }
        else {
            this.moveToTab2 = false;
            this.showRequiredMsg = true;
        }
    }

    showdaterange(val) {
        if (this.showsubmission) {
            this.showsubmission = false;
            this.showsubmissionrange = val;
        } else {
            this.showsubmission = val;
            this.showsubmissionrange = false;
        }

    }

    exportList() {
        this.enablePagination = false;
        this.advancesearchfields.isPagination = this.enablePagination;
      const today: string = moment().format('D MMM YYYY HH:mm:ss');
      const options = {
        showLabels: true,
        headers: this.headerData
      };
      this._dataService.getSearchLeadList(this.advancesearchfields, (result) => {
            this.exportData = result;
            this.exportData.beans.forEach(eachObj => {
                this.temp = {};
                this.prepareCurrentToSave.forEach(prefprop => {
                    if (eachObj[prefprop.property] != "" || eachObj[prefprop.property] != null) {
                        if (prefprop.property == "submissionDate" || prefprop.property == "dateEntered") {
                            eachObj[prefprop.property] = moment(eachObj[prefprop.property]).format("MM/DD/YYYY ");
                        }
                        if(eachObj[prefprop.property] == 'mobileNumber' || eachObj[prefprop.property] == 'phoneNumber'){
                          eachObj[prefprop.property] = Number(eachObj[prefprop.property])
                        }
                        this.temp[prefprop.label] = eachObj[prefprop.property];
                    } else {
                        this.temp[prefprop.label] = null;
                    }
                });
                this.finalExportData.push(this.temp);
            });
            new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
        });
        this.enablePagination = true;
    }

    getPreference() {
        this.current = [];
        this.remaining = [];
        this._leadService.getUserPreference(this.userId, (result) => {
            if (result.length != 0) {
                result.forEach(each => {
                    this.current.push(each.setting.label);
                });
                this._leadService.getviewSettings(allPreference => {
                    allPreference.forEach(res => {
                        this.refine.push(res.label);
                    });
                  const thisObj = this;
                  this.refine.filter(function (item) {
                        if (thisObj.current.indexOf(item) === -1) {thisObj.remaining.push(item)}
                    });
                });
            } else {[this.current, this.remaining] = this._leadService.setDefaultPreferenceForLead(this.current, this.remaining);}
        });

    }

    setUserPreference() {
        //To assign active class
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");

        this.savePreference = {};
        this.prepareCurrentToSave = [];
        this.finalExportData = [];
        this.rowdata = [];
        this.headerData = [];
        this._leadService.getviewSettings(allPreference => {
            allPreference.forEach(field => {
                this.current.forEach((obj, index) => {
                    if (field.label == obj) {
                        this.headerData.splice(index, 0, obj);
                      const object = field.property;
                      const refined = object.substring(object.indexOf(".") + 1);
                      field.property = refined.trim();
                        this.prepareCurrentToSave.splice(index, 0, {
                            "label": obj,
                            "property": field.property,
                        })
                    }
                })
            });

        });
        this.rowdata = this.prepareCurrentToSave;
    }

    reset() {
        this.current = [];
        this.remaining = [];
        this.addToRemaining = [];
        this.addTocurrent = [];
        this.refine = [];
        this.getPreference();
    }

    returnToSearch() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.add("active");
        tab11.classList.remove("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
    }

    returnToFieldSettings() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.add("active");
        tab12.classList.remove("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
    }

    hideSelectMsg() {
        this.showRequiredMsg = false;
    }
    /*
     * @author Nagendra
     * @uses To get event id values
     * @date 22-10-2018
     * @modified date 25-10-2018
     */
    getEventId() {
        this._leadService.getEventWithDescription(result => {
            this.eventValues = result
        })

    }
    /*
     * @author Nagendra
     * @uses To get VOI values
     * @date 22-10-2018
     * @modified date 25-10-2018
     */
    getVOIValues() {
        this._leadService.getVOIMakeModel(result => {
            this.VOIWithMakeModel = result
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/leads/components/lead-export.component.ts